import React from 'react';

function Tnc() {
  return (
    <>
<section className="relative py-16 bg-center" style={{
  backgroundImage: "url('https://img.cdn.biz.id/file/7b6996b5914cbb9f6535c.jpg')",
  backgroundSize: 'cover',
  height:'400px'
}}>
  <div className="absolute inset-0 bg-black opacity-50"></div>
  <div className="relative flex items-center justify-center h-full px-4 text-center text-white">
    <div>
      <h1 className="text-3xl font-bold mb-4">Syarat dan Ketentuan</h1>
      <p className="text-lg">
        We are a premier car rental company that offers exceptional service and reliable vehicles to our customers. Our commitment to providing a hassle-free rental experience is at the core of everything we do, and we take pride in ensuring that every customer is satisfied with their rental.
      </p>
    </div>
  </div>
</section>       
    <div className="min-h-screen py-8 text-lg">
      <div className="max-w-4xl mx-auto bg-white rounded-lg p-8 space-y-8">
        {/* Company Requirements */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-gray-800">Persyaratan Rental/Sewa Mobil untuk Perusahaan</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>Fotokopi SIUP dan NPWP</li>
            <li>Fotokopi akte pendiri perusahaan</li>
            <li>Fotokopi Tanda Daftar perusahaan</li>
            <li>Surat keterangan domisili perusahaan</li>
            <li>Surat pengesahan keputusan menteri Hukum dan HAM</li>
            <li>Fotokopi KTP direksi, dan pejabat yang bertanggung jawab.</li>
            <li>Surat kuasa bila bukan direktur perusahaan yang bertanggung jawab.</li>
            <li>Fotokopi SIM pengemudi.</li>
            <li>Survey lokasi domisili perusahaan.</li>
          </ul>
        </div>
        <hr className="w-24 border-red-600 mx-auto my-5" />
        {/* Individual Requirements */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-gray-800">Persyaratan Rental/Sewa Mobil untuk Perorangan</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>Fotokopi bukti kepemilikan rumah atau tempat tinggal</li>
            <li>Fotokopi PBB</li>
            <li>Fotokopi NPWP</li>
            <li>Fotokopi KTP atau KITAS (pemohon dan penjamin)</li>
            <li>Fotokopi KK</li>
            <li>Fotokopi Passport</li>
            <li>Fotokopi SIM</li>
            <li>Fotokopi ID Card tempat bekerja</li>
            <li>Kartu nama</li>
            <li>Memiliki penjamin (bila diperlukan)</li>
            <li>Ketersediaan lahan parkir yang layak dan aman.</li>
          </ul>
        </div>

        {/* Notes */}
        <div className="space-y-4">
          <h2 className="text-2xl font-bold text-gray-800">Note</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>Prosedur survey kami harus dilakukan minimal 3 hari sebelum hari H. (Perusahaan memerlukan waktu untuk pengecekan legalitas/keaslian data customer).</li>
            <li>Customer wajib membayar uang deposit sebagai jaminan asuransi (dikembalikan di masa akhir sewa).</li>
            <li>Kendaraan hanya dapat dikemudikan oleh orang yang memiliki SIM nasional Indonesia atau SIM internasional.</li>
            <li>Semua data yang disertakan berupa fotokopi. Penyewa wajib menunjukan dokumen asli kepada surveyor ketika disurvey untuk memastikan keaslian dokumen dengan fotokopi yang diberikan.</li>
            <li>Dilarang meninggalkan STNK, kunci kontak, dan karcis parkir di dalam kendaraan yang sedang diparkir.</li>
            <li>Penggantian kendaraan tidak berlaku jika kerusakan/kecelakaan diakibatkan kelalaian penyewa.</li>
            <li>Penyewa dan driver tambahan harus memiliki usia antara 21 hingga 65 tahun untuk kategori mobil standar dan 25 hingga 65 tahun untuk kategori mobil mewah.</li>
            <li>Penyewaan tanpa supir diwajibkan untuk memonitor perawatan kendaraan.</li>
            <li>Hasil survey adalah data independen dari perusahaan kami. Jika terjadi penolakan hasil survey, perusahaan tidak akan memberikan informasi apapun kepada customer mengenai hasil analisa survey.</li>
            <li>Sewa motor saat ini kami hanya melayani untuk perusahaan.</li>
            <li>Deposit sewa Rp 1.000.000,- per motor, pengembalian deposit H+3 dari tanggal motor dikembalikan dan setelah motor dilakukan pengecekan oleh pihak rental.</li>
          </ul>
        </div>
      </div>
    </div>
    </>
  );
};

export default Tnc;